<template>
  <div class="page-schedule" v-scroll-spy="scrollPos">

    <top-subpage-section>
      <page-header title="Events &amp; Schedule">
        <div class="columns is-gapless is-flex-mobile has-text-centered" :class="[{ 'is-centered': !isDesktop }]">
          <div class="column" v-if="isDesktop">&nbsp;<!-- stub --></div>
          <div class="column is-narrow subnav-item">
            <a href="#" @click="$event.preventDefault();onScrollTo('schedule', 'schedule-sub-section')">
              <img src="../assets/ic_schedule.svg" width=80 style="width:80px;" /><br />
              <h4 class="text">
                Schedule
              </h4>
            </a>
          </div>
          <div v-for="(item, index) in items" :key="item.title_slug" class="column is-narrow subnav-item">
            <a :href="$route.name + '?anchor=' + item.title_slug" @click="$event.preventDefault();onScrollTo('schedule', item.title_slug)">
              <img v-if="item.icon === 'strawberry'" src="../assets/ic_strawberry.svg" width=80 style="width:80px;" />
              <img v-else-if="item.icon === 'king'" src="../assets/ic_kingofwing.svg" width=80 style="width:80px;" />
              <img v-else-if="item.icon === 'people'" src="../assets/ic_peopleschoice.svg" width=80 style="width:80px;" />
              <img v-else src="../assets/ic_info.svg" width=80 style="width:80px;" />
              <br />
              <h4 class="text">
                {{ item.title_short }}
              </h4>
            </a>
          </div>
        </div>
        <!-- <br />
        <h2 v-for="(item, index) in items" :key="item.title_slug">
          <a href="#" @click="$event.preventDefault();onScrollTo('schedule', item.title_slug)">{{ item.title }}</a>
        </h2>
        <br />
        <h2>
          <a href="#" @click="$event.preventDefault();onScrollTo('schedule','schedule-1')">Schedule</a>
        </h2> -->
      </page-header>
    </top-subpage-section>

    <div class="page-content-bg">

      <schedule-sub-section id="schedule-sub-section" date="2017-5-12" title="Friday, May 12th Schedule"></schedule-sub-section>

      <event-sub-section :id="item.title_slug" v-for="item in items" :key="item.id" :slug="item.title_slug" :title="item.title" :item="item"></event-sub-section>

    </div>

    <vm-back-top :bottom="45" :right="25" :duration="1000" :timing="'ease'" v-if="false">
      <div class="top"><span></span></div>
    </vm-back-top>
  </div>
</template>

<script>
import Site from '@/apis/Site'
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
import PageHeader from '@/components/PageHeader'
import TopSubpageSection from '@/components/TopSubpageSection'
import ScheduleSubSection from './ScheduleSubSection'
import EventSubSection from './EventSubSection'

export default {
  name: 'schedule',
  components: {
    DivContainer,
    PageHeader,
    TopSubpageSection,
    ScheduleSubSection,
    EventSubSection
  },
  data () {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0,
      items: [],
      loading: true,
      error: undefined
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor)
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor)
      }.bind(this), 2000)
    }

    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.refresh()
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: -30 })
      }
    },

    getEventAll () {
      Site.eventAll()
      .then((data) => {
        this.loading = false
        // console.log(data)
        if (!data) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return
        }

        if (data && data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            var event = data[i]
            var name = event.title_slug
            if (!name || name.length <= 0) {
              data[i].icon = 'misc'
            } else if (name && name.indexOf('strawberry') !== -1) {
              data[i].icon = 'strawberry'
            } else if (name.indexOf('king') !== -1 || name.indexOf('wing') !== -1) {
              data[i].icon = 'king'
            } else if (name.indexOf('people') !== -1 || name.indexOf('choice') !== -1) {
              data[i].icon = 'people'
            } else {
              data[i].icon = 'misc'
            }

            data[i].title_short = data[i].title.replace(/competition/ig, '')
          }
        }

        this.items = data
      })
      .catch((error) => {
        this.loading = false
        this.error = 'Unable to load, please kindly refresh the page.'
        console.log(error)
      })
    },

    refresh () {
      this.getEventAll()
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-schedule {
  position: relative;

  .page-content-bg {
    // background-image: url(../assets/menubg.jpg);
    // background-repeat: no-repeat;
    // background-position: top;
  }
}

</style>



// WEBPACK FOOTER //
// Schedule.vue?807b9c7c